import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authReturnPath } from '../utils/authReturnPath';

const GuestRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  
  if (token) {
    return <Navigate to={authReturnPath(location.search, location.state)} replace />;
  }

  return <>{children}</>;
};

export default GuestRoute;
